import * as t from "io-ts";
import { PRE_PROTOCOL } from "./pre-protocol.js";
import { V1 } from "./v1.js";
import { V2 } from "./v2.js";
import { versionName as v3VersionName, messagesFromIFrame as v3MessagesFromIFrame, messagesFromComponent as v3MessagesFromComponent } from "./v3.js";
export const VERSIONS = ["pre-protocol", "v1", "v2", v3VersionName];
export const incomingMessage = t.union([
    PRE_PROTOCOL.incoming,
    V1.incoming,
    V2.incoming,
    v3MessagesFromIFrame
]);
export const outgoingMessage = t.union([
    PRE_PROTOCOL.outgoing,
    V1.outgoing,
    V2.outgoing,
    v3MessagesFromComponent
]);
